import { useState, useEffect, useRef } from "react";
import PillIcon from "../../icons/usp-pill.svg";
import ConsultationIcon from "../../icons/usp-consultation.svg";
import BoxIcon from "../../icons/usp-box.svg";
import ShieldCheckIcon from "../../icons/usp-shield-check.svg";
import BadgeEuroIcon from "../../icons/usp-badge-euro.svg";
import UsersIcon from "../../icons/usp-users.svg";
import BookCheckIcon from "../../icons/usp-book-check.svg";
import StarIcon from "../../icons/usp-star.svg";
import AwardIcon from "../../icons/usp-award.svg";
import * as translator from "../../utils/translator";
import { useParams } from "react-router-dom";



export default function UspBarV2025() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);
  const animationRef = useRef(null);
  const scrollPosRef = useRef(0);
  const {country} = useParams();
  const language = translator.getLanguageByCountry(country);

  const usps = [
    { icon: PillIcon, text: translator.translate(language, "authentication", "UspBar/1") },
    { icon: ConsultationIcon, text: translator.translate(language, "authentication", "UspBar/2") },
    { icon: BoxIcon, text: translator.translate(language, "authentication", "UspBar/3") },
    { icon: ShieldCheckIcon, text: translator.translate(language, "authentication", "UspBar/4") },
    { icon: BadgeEuroIcon, text: translator.translate(language, "authentication", "UspBar/5") },
    { icon: UsersIcon, text: translator.translate(language, "authentication", "UspBar/6") },
    { icon: BookCheckIcon, text: translator.translate(language, "authentication", "UspBar/7").replace(":categories_count", country?.toLowerCase() === "de" ? "40" : "36") },
    { icon: StarIcon, text: translator.translate(language, "authentication", "UspBar/8") },
    { icon: AwardIcon, text: translator.translate(language, "authentication", "UspBar/9").replace(":years_trust", (d => d.getFullYear() - 2018 - (d.getMonth() < 3 ? 1 : 0))(new Date())) },
  ];

  // Mobile: rotate through USPs
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % usps.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Desktop: continuous horizontal scroll
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    function animate() {
      scrollPosRef.current += 0.5;
      const halfWidth = container.scrollWidth / 2;
      if (scrollPosRef.current >= halfWidth) {
        scrollPosRef.current = 0;
      }
      container.style.transform = `translateX(-${scrollPosRef.current}px)`;
      animationRef.current = requestAnimationFrame(animate);
    }

    animationRef.current = requestAnimationFrame(animate);
    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, []);

  const allUsps = [...usps, ...usps];

  return (
    <div className="w-full bg-[#08080a]">
      {/* Mobile */}
      <div className="block lg:hidden w-full h-[40px] overflow-hidden">
        <div className="relative w-full h-full flex items-center px-4">
          <p className="text-[11px] font-poppins font-normal leading-[1.2] text-white mr-3 flex-shrink-0">
            Warum DoktorABC?
          </p>
          <div className="w-[1px] h-[31px] bg-[#3d404d] mr-3 flex-shrink-0" />
          <div className="flex-1 flex items-center justify-center gap-[9px] relative h-full">
            {usps.map((usp, index) => (
              <div
                key={index}
                className={`absolute inset-0 flex items-center justify-center gap-[9px] transition-opacity duration-300 ${
                  index === currentIndex ? "opacity-100" : "opacity-0"
                }`}
              >
                <div className="bg-[#3d404d] rounded-[20px] w-[20px] h-[20px] flex items-center justify-center overflow-hidden flex-shrink-0">
                  <img src={usp.icon} alt="" className="w-[12px] h-[12px] object-contain" />
                </div>
                <p className="text-[11px] font-poppins font-normal leading-[1.2] text-white truncate">
                  {usp.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Desktop */}
      <div className="hidden lg:block w-full h-[40px] overflow-hidden">
        <div className="relative w-full h-full flex items-center">
          <div className="absolute left-0 top-0 h-full bg-[#08080a] z-[10] flex items-center pl-[20px] pr-[10px]">
            <p className="text-[11px] font-poppins font-normal leading-[1.2] text-white">
              Warum DoktorABC?
            </p>
            <div className="absolute right-0 top-1/2 [transform:translateY(-50%)] w-[1px] h-[31px] bg-[#3d404d] z-[10]" />
          </div>
          <div
            ref={scrollRef}
            className="absolute left-[160px] flex items-center gap-[34px] h-full z-[1]"
          >
            {allUsps.map((usp, index) => (
              <div key={index} className="flex items-center gap-[9px] flex-shrink-0">
                <div className="bg-[#3d404d] rounded-[20px] w-[20px] h-[20px] flex items-center justify-center overflow-hidden flex-shrink-0">
                  <img src={usp.icon} alt="" className="w-[12px] h-[12px] object-contain" />
                </div>
                <p className="text-[11px] font-poppins font-normal leading-[1.2] text-white whitespace-nowrap">
                  {usp.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
